export const SUBJECT_COLORS = {
  Math: '#6366f1',
  Science: '#059669',
  'Social Studies': '#d97706',
  'Language Arts': '#db2777',
};

export const SUBJECT_GRADIENTS = {
  Math: 'linear-gradient(135deg, #6366f1, #818cf8)',
  Science: 'linear-gradient(135deg, #059669, #34d399)',
  'Social Studies': 'linear-gradient(135deg, #d97706, #fbbf24)',
  'Language Arts': 'linear-gradient(135deg, #db2777, #f472b6)',
};

export const SUBJECT_EMOJIS = {
  Math: '📐',
  Science: '🔬',
  'Social Studies': '🌍',
  'Language Arts': '📖',
};

export const SUBJECTS = ['Math', 'Science', 'Social Studies', 'Language Arts'];

export const TOPICS = {
  Math: [
    'Number Operations',
    'Algebra',
    'Geometry',
    'Statistics & Probability',
    'Ratios & Proportions',
    'Functions',
    'Data Analysis',
  ],
  Science: [
    'Life Science',
    'Earth Science',
    'Physical Science',
    'Energy & Waves',
    'Ecosystems',
    'Human Body Systems',
    'Scientific Reasoning',
  ],
  'Social Studies': [
    'US History',
    'World History',
    'Civics & Government',
    'Economics',
    'Geography',
    'US Constitution',
  ],
  'Language Arts': [
    'Reading Comprehension',
    'Grammar & Usage',
    'Vocabulary in Context',
    'Argument Analysis',
    'Informational Texts',
    'Extended Response',
  ],
};
